<template>
  <div class="utube-video-section">
    <v-row class="mt-4" no-gutters>
      <v-col cols="12" class="d-flex justify-center">
        <div class="webinar-container">
          <img 
            :src="require('@/assets/images/web.jpg')" 
            alt="Webinar Poster" 
            class="webinar-img"
          >
          <a href="https://forms.gle/BEeAp2386ud3iSgQ7" target="_blank" class="register-btn">
            Register Now
          </a>
        </div>
      </v-col>
    </v-row>

    <div class="utube-video">
      <v-row no-gutters>
        <v-col cols="12" class="video">
          <div class="d-flex justify-center video-container">
            <iframe 
              src="https://www.youtube.com/embed/rTjaGwi92zk?si=8XTlQHwFrAlzXavR" 
              title="YouTube video player" 
              frameborder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" 
              allowfullscreen
            ></iframe>
          </div>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WebinarVideoComponent'
}
</script>

<style scoped>
.utube-video-section {
  padding: 40px 0;
  background-color: #ffffff;
}

/* --- Website Link Animation (Right Side) --- */
.moving-link {
  display: flex;
  align-items: center;
  color: #28a745;
  text-decoration: none;
  font-weight: bold;
  font-size: 1.1rem;
  padding: 8px 20px;
  border: 2px solid #28a745;
  border-radius: 50px;
  background: rgba(40, 167, 69, 0.05);
  transition: 0.3s;
  animation: pulse-green 2s infinite; /* လှုပ်နေစေရန် */
}

.dot {
  height: 10px;
  width: 10px;
  background-color: #28a745;
  border-radius: 50%;
  margin-left: 10px;
  display: inline-block;
}

@keyframes pulse-green {
  0% { transform: scale(1); box-shadow: 0 0 0 0px rgba(40, 167, 69, 0.4); }
  70% { transform: scale(1.05); box-shadow: 0 0 0 10px rgba(40, 167, 69, 0); }
  100% { transform: scale(1); box-shadow: 0 0 0 0px rgba(40, 167, 69, 0); }
}

/* --- Image & Button Container --- */
.webinar-container {
  position: relative;
  max-width: 1000px;
  width: 100%;
  margin-bottom: 10px;
}

.webinar-img {
  width: 100%;
  height: auto;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.1);
  display: block;
}

.register-btn {
  position: absolute;
  bottom: 30px; /* နေရာကို နည်းနည်းပြန်ညှိထားပါတယ် */
  right: 30px;
  background-color: #28a745;
  color: white;
  
  /* Size ကြီးရန် ဒီနေရာတွေကို ပြင်ထားပါတယ် */
  padding: 16px 40px;      /* padding ကို တိုးလိုက်တာပါ */
  font-size: 1.4rem;       /* စာလုံးဆိုဒ်ကို ကြီးလိုက်တာပါ */
  
  border-radius: 50px;
  text-decoration: none;
  font-weight: bold;
  box-shadow: 0 6px 20px rgba(0,0,0,0.4); /* အရိပ်ကို ပိုထင်ရှားအောင် လုပ်ထားပါတယ် */
  transition: all 0.3s ease;
  z-index: 10;
  border: 2px solid white;
  display: inline-block;
  cursor: pointer;
}

.register-btn:hover {
  background-color: #1e7e34;
  transform: scale(1.1); /* Mouse တင်ရင် ပိုကြီးလာအောင် ၁.၁ ဆ ပြောင်းထားပါတယ် */
  box-shadow: 0 8px 25px rgba(0,0,0,0.5);
}

/* --- Video Styling --- */
.utube-video {
  padding: 30px 15% 40px;
}

div iframe {
  width: 1000px;
  height: 560px;
  border-radius: 15px;
  box-shadow: 0 10px 40px rgba(0,0,0,0.1);
}

/* --- Responsive Layout --- */
@media (max-width: 1200px) {
  .utube-video { padding: 30px 3% 40px; }
  .webinar-container, div iframe { width: 85%; height: 450px; }
}

@media (max-width: 768px) {
  .webinar-container, div iframe { width: 95%; height: 350px; }
  .register-btn {
    padding: 12px 24px;
    font-size: 1rem;
    bottom: 20px;
    right: 20px;
  }
  .moving-link { font-size: 0.9rem; padding: 6px 15px; }
}

@media (max-width: 480px) {
  div iframe { height: 210px; }
  .register-btn { font-size: 0.75rem; padding: 6px 12px; }
}
</style>